import GraphCreatePanel from './GraphCreatePanel';
import GraphTransformsPanel from './GraphTransformsPanel';
import StyleLayoutPanel from './StyleLayoutPanel';
import StyleAxesPanel from './StyleAxesPanel';
import StyleLegendPanel from './StyleLegendPanel';
import StyleNotesPanel from './StyleNotesPanel';
import StyleShapesPanel from './StyleShapesPanel';
import StyleSlidersPanel from './StyleSlidersPanel';
import StyleImagesPanel from './StyleImagesPanel';
import StyleTracesPanel from './StyleTracesPanel';
import StyleColorbarsPanel from './StyleColorbarsPanel';
import StyleUpdateMenusPanel from './StyleUpdateMenusPanel';
import GraphSubplotsPanel from './GraphSubplotsPanel';

export {
  GraphCreatePanel,
  GraphTransformsPanel,
  StyleLayoutPanel,
  StyleAxesPanel,
  StyleLegendPanel,
  StyleNotesPanel,
  StyleShapesPanel,
  StyleSlidersPanel,
  StyleImagesPanel,
  StyleTracesPanel,
  StyleColorbarsPanel,
  StyleUpdateMenusPanel,
  GraphSubplotsPanel,
};



// WEBPACK FOOTER //
// src/default_panels/index.js